// extracted by mini-css-extract-plugin
export default {"field":"LabelEditStep_field__w0GKS","fieldLabel":"LabelEditStep_fieldLabel__a8ArG","controls":"LabelEditStep_controls__zZQov"};